export default {
  state: {
    contentfulEnvSettings: {},
  },
  getters: {
    getContentfulEnvSettings: (state) => state.contentfulEnvSettings,
    getFeatureFlagByName: (state) => (featureFlagName) => Boolean(state.contentfulEnvSettings?.[featureFlagName]),
  },
  mutations: {
    setContentfulEnvSettings: (state, payload) => {
      // eslint-disable-next-line no-param-reassign
      state.contentfulEnvSettings = payload;
    },
  },
  actions: {
    fetchContentfulEnvSettings({ commit }) {
      commit('setContentfulEnvSettings', window?.content?.envSettings || {});
    },
    setContentfulEnvSettings({ commit }, payload) {
      commit('setContentfulEnvSettings', payload);
    },
  },
};
